import React, { useEffect } from 'react'
import { useParams } from 'react-router'

import MyhouseInsuranceModifyPage from '@Components/templates/MyhouseInsuranceModifyPage'
import useInsuranceRegister from '@Hooks/myhouse/insurance/useInsuranceRegister'
import useMain from '@Hooks/myhouse/main/useMain'
import useInsurance from '@Hooks/myhouse/insurance/useInsurance'

interface ModifyParam {
  houseNo: string
  insuranceSequence: string
}

function InsuranceModifyFormPage() {
  const params = useParams<ModifyParam>()
  const { setCurrentHouseNo } = useMain()
  const { insurance, loadInsurance, loadInsuranceHouse, loadInsuranceSelectBox } = useInsurance()
  const { setHouseNo, setHouseLabel } = useInsuranceRegister()

  const houseNo = Number(params.houseNo)
  const insuranceSequence = Number(params.insuranceSequence)

  useEffect(() => {
    loadInsuranceSelectBox()
    const currentHouseNo = Number(houseNo)
    loadInsurance({ houseNo: currentHouseNo, insuranceSequence: insuranceSequence })
    setCurrentHouseNo({ currentHouseNo: currentHouseNo })
    setHouseNo(currentHouseNo)
    loadInsuranceHouse(currentHouseNo)
  }, [houseNo, insuranceSequence])

  useEffect(() => {
    setHouseLabel(insurance.insuranceHouse)
  }, [insurance.insuranceHouse.fetchStatus])

  return (
    <>
      <MyhouseInsuranceModifyPage />
    </>
  )
}

export default InsuranceModifyFormPage
